import { Outlet } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { Stack } from '@mui/material';

import { ServerNotificationBanner } from '@/entities/user/settings';

import { MixpanelEvents } from '@/shared/thirdParty';

// eslint-disable-next-line boundaries/element-types
import { DesktopSidebar } from '../../../sidebar';
import { SContainer } from './styled';

const LS_LOCKED_SIDEBAR = 'lockedSidebar';

export const MainLayout = () => {
  const [lockedSidebar, setLockedSidebar] = useLocalStorage(LS_LOCKED_SIDEBAR, true);

  const handleLockedSidebar = () => {
    setLockedSidebar(!lockedSidebar);

    if (lockedSidebar) {
      MixpanelEvents.hideSideBarClick();
    } else {
      MixpanelEvents.lockSideBarClick();
    }
  };

  return (
    <SContainer>
      <DesktopSidebar lockedSidebar={lockedSidebar} handleLockedSidebar={handleLockedSidebar} />
      <Stack
        sx={{
          width: {
            laptop: lockedSidebar ? 'calc(100% - 208px)' : '100%',
          },
        }}
        flex="1"
      >
        <ServerNotificationBanner />
        <Outlet />
      </Stack>
    </SContainer>
  );
};
